$(document).ready(function(){

	//INTIALIZE RANGE SLIDER
	 $('#age-slider').rangeslider({
		// Feature detection the default is `true`.
		// Set this to `false` if you want to use
		// the polyfill also in Browsers which support
		// the native <input type="range"> element.
		polyfill: false,

		// Default CSS classes
		rangeClass: 'rangeslider',
		disabledClass: 'rangeslider--disabled',
		horizontalClass: 'rangeslider--horizontal',
		fillClass: 'rangeslider__fill',
		handleClass: 'rangeslider__handle',

		// Callback function
		onInit: function() {
			$rangeEl = this.$range;
	
			var min = parseInt(this.$element.attr('min'));
			var max = parseInt(this.$element.attr('max'));

			// add labels
			$rangeEl.append('<div class="rangeslider__labels"></div>');
			$rangeEl.find('.rangeslider__labels').append('<span class="rangeslider__labels__label">' + min + ' Yr</span>');
			$rangeEl.find('.rangeslider__labels').append('<span class="rangeslider__labels__label">' + max + '+ Yrs</span>');
		},

		// Callback function
		onSlide: function(position, value) {
			if(this.value == 1)
			{
				$('.selected-age').text('NEWBORN');				
			}
			else if(this.value == 65)
			{
				$('.selected-age').text(this.value+'+ YEARS');				
			}
			else
			{
				$('.selected-age').text(this.value+' YEARS');				
			}
		},

		// Callback function
		onSlideEnd: function(position, value) {}
	});

	 //TOGGLE BUTTON
	 $('.toggle-btn input:radio[name="type"]').change(function(e) {
        
        var indicator = $(this).parent('.toggle-btn').find('span');
        if ($('input[name=type]:checked').val() == 'wakeup') {
            $(indicator).removeClass('right');
        }
        else {
            $(indicator).addClass('right');
        }
    });

	$('.calculate-btn').on('click',function(){
		
		//GET ALL INPUT VALUES
		var age = $('input[name=age]').val();
		var type = $('input[name=type]:checked').val();
		
		var hour = parseInt($('.chosen').first().text());
        var min =  parseInt($('.chosen:eq(1)').text());
        var dayHalf = $('.chosen').last().text();
		
		//CONVERT INTO OBJECT
		obj = {'age':age, 'type':type, 'hour': hour, 'min':min, 'dayHalf':dayHalf};
      	
      	//CALL TO FUNCTION FOR RESULT
		result = calculateTime(obj);

		//APPEND RESULT
		if(type == 'wakeup')
		{
			var text = 'To wake up at '+hour+':'+$('.chosen:eq(1)').text()+' '+dayHalf+', you should go to bed at:';
		}
		else
		{
			var text = 'To go to bed at '+hour+':'+$('.chosen:eq(1)').text()+' '+dayHalf+', you should wake up at:';
		}
		$('#text-area').text(text);

		$('.result-wrapper .box-wrapper').html(getHTML(result));

		$('.form-wrapper').fadeOut(300,function(){
			$('.result-wrapper').fadeIn(300);
		})
	});

	$('.calculate-btn-reset').on('click',function(){
		$('.result-wrapper').fadeOut(300,function(){
			$('.form-wrapper').fadeIn(300);
		});
	});

	//FUNCTION TO CALCULATE RESULTS
	function calculateTime(obj)
	{
		//DEFINE ALL VARIABLES
		var timeToFallAsleep = 15;
	    var minInHour = 60;
	    var hourBase = 12;
	    var interval = 50;
	    var startTime;
	    var min,max;

	    //FIND START TIME AND INTERVAL
	    if(obj.age == 1 || obj.age == 2)
    	{
    		startTime = 800;
    		min = 11;
    		max = 14;
	    }
	    else if(obj.age >= 3 && obj.age <= 5)
	    {
	    	startTime = 750;
	    	min = 10;
    		max = 13;
	    }
	    else if(obj.age >= 6 && obj.age <= 13)
	    {
	    	startTime = 650;
	    	min = 9;
    		max = 11;
	    }
	    else if(obj.age >= 14 && obj.age <= 17)
	    {
	    	startTime = 600;
	    	min = 8;
    		max = 10;
	    }
	    else if(obj.age >= 18 && obj.age <= 64)
	    {
	    	startTime = 540;
	    	interval = 90;
	    	min = 7;
    		max = 9;
	    }
	   	else if(obj.age >= 65)
	   	{
	   		startTime = 540;
	    	interval = 90;
	    	min = 7;
    		max = 8;
	   	}
	   	var result = [];
    	
    	//LOOP THROUGH RESULT ITEMS COUNT
	   	for (var i = 1; i <= 4; i++) {	   		
	   		
	   		//CONVERT TIME TO 08:00 AM FORMAT
	   		full_time_string = obj.hour+':'+obj.min+' '+obj.dayHalf; 
	   		time = moment(full_time_string, ["h:mm A"]).format("HH:mm");

	   		//GET CURRENT TIME AND SET INPUT TIME TO DATE
	   		date = moment();
	   		date = date.set({'hours':time.split(':')[0],'minutes':time.split(':')[1]});

	   		//ADD OR SUBTRACT ACCORDING TO TYPE
	   		if(obj.type == 'wakeup')
	   			time = moment(date).subtract(startTime + timeToFallAsleep, 'minutes').format("h:mm A");
	   		else
	   			time = moment(date).add(startTime + timeToFallAsleep, 'minutes').format("h:mm A");
			
			//CALCULATE SLEEP TIME
			total_sleep = (startTime + timeToFallAsleep)/minInHour;
 			
 			if((startTime + timeToFallAsleep) % minInHour >= 30)
 				total_sleep = Math.trunc(total_sleep)+0.5;
 			else
 				total_sleep = Math.trunc(total_sleep);

 			//CALCULATE TOTAL CYCLES
 			total_cycles =  Math.trunc((startTime + timeToFallAsleep) / interval);

 			result.push({'time':time,'cycles':total_cycles,'sleep':total_sleep,'min':min, 'max':max});
    		startTime -= interval;
	   	}
	   	return result;    	
	}

	//FUNCTION TO GENERATE HTML OF RESULT
	function getHTML(result)
	{
		html = '<div class="box-inner-wrapper common">';

		$.each(result,function(index,value){
			html += '<div class="box"> <span class="time-heading"> '+value.time.split(' ')[0]+'<span class="time-span">'+value.time.split(' ')[1]+'</span>';

			if(value.sleep >= value.min && value.sleep <= value.max)
			{
				html += ' <span class="suggested">Suggested</span>';
			}

			html += ' </span><span class="sub-text"> '+value.sleep+' hrs of sleep, '+value.cycles+' sleep cycles </span> </div>';

			if(index == 1)
			{
				html += '</div><div class="box-inner-wrapper common">';
			}
		});

		html += ' </div>' ;
		return html;
	}

});